import {
  MultiSelectOption,
  TaskPeril,
  TaskTemplate,
  TaskTemplatesPostBody,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';
import { v4 as uuidv4 } from 'uuid';
import invariant from 'tiny-invariant';

const APIM_SERVICE_TASKS_TEMPLATES_URL = 'dispatch/service/tasktemplates';
const APIM_SERVICE_PERILS_URL = (tenantId: string) =>
  `configuration/${tenantId}/perils`;

export async function getTaskTemplates(tenantId: string) {
  return dispatchClient.get<TaskTemplate[]>(
    `${APIM_SERVICE_TASKS_TEMPLATES_URL}?tenantId=${tenantId}`
  );
}

export async function getTaskTemplate(taskTemplateId: string) {
  return dispatchClient.get<TaskTemplate>(
    `${APIM_SERVICE_TASKS_TEMPLATES_URL}/${taskTemplateId}`
  );
}

export async function upsertTaskTemplates(
  templateId: string | undefined,
  data: Partial<TaskTemplatesPostBody>,
  tenantId?: string
) {
  return dispatchClient.put<TaskTemplate[]>(
    `${APIM_SERVICE_TASKS_TEMPLATES_URL}/${templateId || ''}`,
    { ...data, tenantId: tenantId }
  );
}

export async function getPerils(
  tenantId: string
): Promise<TaskPeril[] | undefined> {
  invariant(tenantId, 'Missing tenantId, cannot fetch perils options');

  const response = await dispatchClient.get<TaskPeril[]>(
    `${APIM_SERVICE_PERILS_URL(tenantId)}`,
    {
      headers: {
        'Request-ID': uuidv4(),
      },
    }
  );

  const perils: TaskPeril[] = response?.data;

  return perils;
}

export async function getPerilOptions(
  tenantId: string
): Promise<MultiSelectOption[] | undefined> {
  try {
    const response = await dispatchClient.get<TaskPeril[]>(
      `${APIM_SERVICE_PERILS_URL(tenantId)}`,
      {
        headers: {
          'Request-ID': uuidv4(),
        },
      }
    );

    const perils: TaskPeril[] = response?.data;

    const perilOptions: MultiSelectOption[] = perils.map(
      (region: TaskPeril) => {
        return {
          title: region.description,
          value: region.code,
        };
      }
    );

    if (response.status === 200 && perilOptions) {
      return perilOptions;
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error fetching perils from API', e);
  }
  return undefined;
}
